const SET_ERRORS = (state, errors) => {
  state.errors = errors;
};

const SET_ERRORS_NOT_ACCEPTABLE = (state, errors) => {
  state.errorsNotAcceptable = errors;
};

const SET_ALERT = (state, alert) => {
  state.alert = alert;
  state.show = true;
};

const SET_ALERT_NOT_ACCEPTABLE = (state, data) => {
  state.errorsNotAcceptable = data;
};

const HIDE_ALERT = state => {
  state.show = false;
};

export default {
  SET_ERRORS,
  SET_ALERT,
  SET_ALERT_NOT_ACCEPTABLE,
  SET_ERRORS_NOT_ACCEPTABLE,
  HIDE_ALERT
};
